import { FC } from "react";
import { ManagingError } from "../validator/UsersManagersShowErrorValidator";
import { useTranslation } from "react-i18next";
import { Alert } from "@mui/material";
import { stylesMUIManagers } from "../styles/managersCreationStyles";

type ManagersConfigTableHeadParams = {
  totalErrors: number;
  tryingToCreateSomething: boolean;
  createManagers: {
    createSuccess: boolean;
    createLoading: boolean;
    createError: string;
    linkActions: boolean;
    usersManagersCreated: number;
  };
  resetValuesCreateManagers: () => void;
  createErrorManagerAllInarix: string[];
  createErrorManagerAllInarixShow: boolean;
  theUserIsGood: {
    email: string;
    role: string | number | undefined;
    assignedGroups: number[];
    isTheassignedGroupsGood: boolean;
    isTheEmailOk: boolean;
    isTheEmailExist: boolean;
    istheRolOk: boolean;
    rowPosition: number;
  }[];
};

const ManagersConfigTableHead: FC<ManagersConfigTableHeadParams> = ({
  totalErrors,
  tryingToCreateSomething,
  createManagers,
  resetValuesCreateManagers,
  createErrorManagerAllInarix,
  createErrorManagerAllInarixShow,
  theUserIsGood,
}) => {
  const [t] = useTranslation("global");

  const managingShowErrors = () => {
    if (totalErrors >= 1 && tryingToCreateSomething) {
      return true;
    } else {
      return false;
    }
  };

  const showServiceError = () => {
    if (createManagers.createError) {
      setTimeout(() => {
        resetValuesCreateManagers();
      }, 3000);

      return (
        <Alert sx={stylesMUIManagers.headAlert} severity="error">
          <div>{createManagers.createError}</div>
        </Alert>
      );
    } else {
      return "";
    }
  };

  const userExistGlobalInarix = () => {
    if (createErrorManagerAllInarix.length >= 1) {
      const globalError = JSON.stringify(createErrorManagerAllInarix);

      return (
        <Alert sx={stylesMUIManagers.headAlert} severity="error">
          {globalError}
        </Alert>
      );
    } else {
      return "";
    }
  };
  return (
    <>
      <div className="step-title-create">
        {t("Users_managers.create_managers")}
      </div>
      <div className="design-scope">{t("Users_managers.create_mang_sub")}</div>
      {showServiceError()}
      {createErrorManagerAllInarixShow ? userExistGlobalInarix() : " "}
      {managingShowErrors() ? (
        <ManagingError
          theUserIsGood={theUserIsGood}
          tryingToCreateSomething={tryingToCreateSomething}
        />
      ) : undefined}
    </>
  );
};

export default ManagersConfigTableHead;
